module.exports = __webpack_public_path__ + "static/media/videoHome2.9d43c895.webm";